import {
  Frys,
  Bakers,
  CityMarket,
  Dillons,
  FredMeyer,
  Gerbes,
  JayC,
  KingSoopers,
  Smiths,
  Kroger,
  MetroMarket,
  Payless,
  QFC,
  PickNSave,
  Marianos,
  Ralphs,
  Amazon,
} from '../../assets/images';

const stores = {
  frys: {
    name: "Fry's",
    logo: Frys,
    links: {
      mole: 'https://www.frysfood.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.frysfood.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.frysfood.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
      /*tomato: 'https://www.isadoramexicanfood.com/', 
      corn: 'https://www.isadoramexicanfood.com/',*/
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  fred_meyer: {
    name: 'Fred Meyer',
    logo: FredMeyer,
    links: {
      mole: 'https://www.fredmeyer.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.fredmeyer.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.fredmeyer.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  smiths: {
    name: "Smith's",
    logo: Smiths,
    links: {
      mole: 'https://www.smithsfoodanddrug.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=IN_STORE&searchType=default_search',
      barbacoa:
        'https://www.smithsfoodanddrug.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=IN_STORE&searchType=default_search',
      pork: 'https://www.smithsfoodanddrug.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=IN_STORE&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  city_market: {
    name: 'City Market',
    logo: CityMarket,
    links: {
      mole: 'https://www.citymarket.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.citymarket.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.citymarket.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  kroger: {
    name: 'Kroger',
    logo: Kroger,
    links: {
      mole: 'https://www.kroger.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.kroger.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.kroger.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  jayc: {
    name: 'Jay C',
    logo: JayC,
    links: {
      mole: 'https://www.jaycfoods.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.jaycfoods.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.jaycfoods.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  metro_market: {
    name: 'Metro Market',
    logo: MetroMarket,
    links: {
      mole: 'https://www.metromarket.net/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.metromarket.net/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.metromarket.net/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  pay_less: {
    name: 'Pay Less',
    logo: Payless,
    links: {
      mole: 'https://www.pay-less.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.pay-less.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.pay-less.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  qfc: {
    name: 'QFC',
    logo: QFC,
    links: {
      mole: 'https://www.qfc.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.qfc.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.qfc.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  gerbes: {
    //TODO: Actualizar links de Gerbes
    name: 'Gerbes',
    logo: Gerbes,
    links: {
      mole: 'https://www.gerbes.com/p/isadora-chicken-with-mole-sauce/0078162400003?fulfillment=PICKUP&searchType=default_search',
      barbacoa:
        'https://www.gerbes.com/p/isadora-barbacoa-mexican-style-seasoned-beef/0078162400001?fulfillment=PICKUP&searchType=default_search',
      pork: 'https://www.gerbes.com/p/isadora-pork-in-green-salsa/0078162400002?fulfillment=PICKUP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  pick_n_save: {
    name: "Pick'N Save",
    logo: PickNSave,
    links: {
      mole: 'https://www.picknsave.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.picknsave.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.picknsave.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  dillons: {
    name: 'Dillons',
    logo: Dillons,
    links: {
      mole: 'https://www.dillons.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.dillons.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.dillons.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  bakers: {
    name: 'Bakers',
    logo: Bakers,
    links: {
      mole: 'https://www.bakersplus.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.bakersplus.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.bakersplus.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  marianos: {
    name: "Mariano's",
    logo: Marianos,
    links: {
      mole: 'https://www.marianos.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.marianos.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.marianos.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  ralphs: {
    //TODO: Actualizar links de Ralphs
    name: "Ralph's",
    logo: Ralphs,
    links: {
      /*mole: 'https://www.frysfood.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.frysfood.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.frysfood.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',*/
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  king_soopers: {
    name: 'King Soopers',
    logo: KingSoopers,
    links: {
      mole: 'https://www.kingsoopers.com/p/isadora-gluten-free-pollo-con-mole/0078162400909?fulfillment=SHIP&searchType=default_search',
      barbacoa:
        'https://www.kingsoopers.com/p/isadora-mexican-style-barbaoca/0078162400908?fulfillment=SHIP&searchType=default_search',
      pork: 'https://www.kingsoopers.com/p/isadora-pork-chile-verde/0078162400910?fulfillment=SHIP&searchType=default_search',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
  },
  amazon: {
    name: "Amazon",
    logo: Amazon,
    links: {
      mole: 'https://www.amazon.com/-/es/Isadora-totalmente-necesita-refrigeración-mexicana/dp/B0C9WBFKGR/ref=sr_1_4?__mk_es_US=ÅMÅŽÕÑ&crid=5NSMK598TDCY&dib=eyJ2IjoiMSJ9.0sYs7jAoOUW1WAk_Z6HKinvpZq-bhFFCrtOhvtRcZbATCaCCOPuQdd2F4m-eBa9xTqJTFXvMQD6041fqN_dtDDFPwSM0bx7T-9cPsNJkBleB5JxjtxPlYZagfs_6LpwOdusTNcbDl5dvVhEcDcwzfsLZ7S9TvrwGhjGHEST0_0HbMeFn_ki_u3NYfylqxH_7aVb4S_TYui4L82dmThWXmllsE1HX8TjZLO4bFSaE8DOZmi8MUaUMN7E1q6MR005DJpUUp1fEjbxnwLbvHHtE8uvrvHqlRR7ECC8sOomRQ5k.82TPHmXBf1mkHl2fzZsRp9ynBWkKa-Ux1_Wbr760piU&dib_tag=se&keywords=isadora&qid=1746638497&s=grocery&sprefix=isadora%2Cgrocery%2C170&sr=1-4',
      barbacoa:
        'https://www.amazon.com/-/es/Isadora-Barbacoa-completamente-cocida-mexicano/dp/B0C9WBDRX4/ref=sr_1_1?__mk_es_US=ÅMÅŽÕÑ&crid=5NSMK598TDCY&dib=eyJ2IjoiMSJ9.0sYs7jAoOUW1WAk_Z6HKinvpZq-bhFFCrtOhvtRcZbATCaCCOPuQdd2F4m-eBa9xTqJTFXvMQD6041fqN_dtDDFPwSM0bx7T-9cPsNJkBleB5JxjtxPlYZagfs_6LpwOdusTNcbDl5dvVhEcDcwzfsLZ7S9TvrwGhjGHEST0_0HbMeFn_ki_u3NYfylqxH_7aVb4S_TYui4L82dmThWXmllsE1HX8TjZLO4bFSaE8DOZmi8MUaUMN7E1q6MR005DJpUUp1fEjbxnwLbvHHtE8uvrvHqlRR7ECC8sOomRQ5k.82TPHmXBf1mkHl2fzZsRp9ynBWkKa-Ux1_Wbr760piU&dib_tag=se&keywords=isadora&qid=1746638497&s=grocery&sprefix=isadora%2Cgrocery%2C170&sr=1-1&th=1',
      pork: 'https://www.amazon.com/-/es/Isadora-totalmente-cocido-necesita-refrigeración/dp/B0C9W5PZ35/ref=sr_1_8?__mk_es_US=ÅMÅŽÕÑ&crid=1323ZGQY3CR3E&dib=eyJ2IjoiMSJ9.1WkP0ao7WhjsvT9Nc4deM1vYJVxK8ascK7_Y8tK7XgSn4yEEcwezNaeo_sekFx0vEsC5mjOl2fmsldB0ZCQ-mpnDTUWs2VincYPzSIMZbm7vkcBxXikHQFZhrBqaL_ONCMcbc2GceR5-eNIg-iEIBEnlp31rYk_gTc9sWUuVvuATUm3gCP0SqJ5pQwWomuW20rbmXa3AJ9Lb8SSAopd0kXm2sb39B2zml1LoOEjTr1N2E6V6JiElxhY74hRr3V_ULxXAgQ0dG3n5auP2lB_8yeR4G9tmcLI7lvi3u5cj9_s.Bm3L5_01kkpmYswJkCS3fhO-Hn8bLX0gmXiVZcdi4pQ&dib_tag=se&keywords=PORK%2BIN%2BGREEN%2BSALSA&qid=1746638428&s=grocery&sprefix=pork%2Bin%2Bgreen%2Bsalsa%2Cgrocery%2C177&sr=1-8&th=1',
      tomato: 'https://www.amazon.com/-/es/Isadora-Arroz-blanco-mexicano-tomate/dp/B0D8M9LM6F/ref=sr_1_4?__mk_es_US=ÅMÅŽÕÑ&crid=2MDBAWAKPTGWY&dib=eyJ2IjoiMSJ9.EGEJ0W0z5EHyBMCsXoEDHwrCwP_QBRIcI24gIADsnGrFuBFa90CERVApYmUTlLHUXayC8B-ahUZntnQ5kUef8yqzkZ0mFYHWsLaNBh1EiQMB-kMZRPpIBmfHpEtS-8e18hD3LR8G1JbBps6zWHfM1Y5jKNgtBX1IYTiQy4BUUSkiKFdDmgN2J6fYg3WiuDRx-QX6xYyevR-uuujoRUjsZqzuUVymzCv2q_MOjbjiw-xo2HvSHXyyp51-QzMmYcJZwpJKA_PjCpIRWUd11NRbOgwDBkS651r6ZzUXDHJqpgU.XvoRR_0HM1PS0l1kbtDj3BohaySgazplO_NoBNQEsAA&dib_tag=se&keywords=MEXICAN+RICE+WITH+TOMATO&qid=1746638226&s=grocery&sprefix=mexican+rice+with+tomato+%2Cgrocery%2C143&sr=1-4', 
      corn: 'https://www.amazon.com/Isadora-Ready-eat-Mexican-white/dp/B0D8M5JFXZ',
    },
    stockMole: true,
    stockBarbacoa: true,
    stockPork: true,
    stockTomato: true,
    stockCorn: true,
  },
};

export default stores;
